import config from "./config";

export const amplifyConfig = {
  Auth: {
    Cognito: {
      identityPoolId: config.AWS_COGNITO_IDENTITY_POOL_ID,
      region: config.AWS_REGION,
      userPoolId: config.AWS_COGNITO_USER_POOL_ID,
      userPoolClientId: config.AWS_COGNITO_CLIENT_ID,
      // loginWith: {
      //   oauth: {
      //     domain: "pwa-test.auth.eu-west-2.amazoncognito.com",
      //     scope: ["email", "openid", "profile"],
      //     redirectSignIn: "http://localhost:3001/login/",
      //     redirectSignOut: "http://localhost:3001/login/",
      //     responseType: "token"
      //   }
      // }
    },
  },
  API: {
    REST: {
        [config.API_NAME]: {
            endpoint: config.API_ENDPOINT,
            region: config.AWS_REGION,
        }
    }
  },
  Storage: {
    track: true,
    S3: {
      bucket: config.STORAGE_BUCKET,
      region: config.AWS_REGION,
    },
  },
  Analytics: {
    disabled: false,
    autoSessionRecord: true,
    autoTrack: {
      pageView: {
        enable: true,
        type: "SPA"
      }
    },
    Pinpoint: { 
        appId: config.AWS_PINPOINT_APPID,
        region: config.AWS_PINPOINT_REGION,
    },
    bufferSize: 100,
    flushInterval: 5000,
    flushSize: 100,
    resendLimit: 5,
    optOut: "NONE"
  },
  cache:{
    itemMaxSize: 3000000,
    capacityInBytes : 5000000
  }
};

export const apiExtras = {
  API: {
    REST: {
      headers: async () => {
        return { 'x-api-key': config.AWS_API_APIKEY };
      }
    }
  }
}